/* FEATURED PRODUCTS - IMAGE CLICK TO PRODUCT PAGE */
document.addEventListener('click', function (e) {
  const mediaArea = e.target.closest(
    '.product-card-wrapper--featured .card__inner, ' +
    '.product-card-wrapper--featured .card__media, ' +
    '.product-card-wrapper--featured .media'
  );

  if (!mediaArea) return;

  /* 这些元素本来就需要单独点击，不拦截 */
  if (
    e.target.closest(
      'a, button, input, select, textarea, .product-card-swatches, .product-card-swatches__item, .slider-button'
    )
  ) {
    return;
  }

  const card = mediaArea.closest('.product-card-wrapper--featured');
  if (!card) return;

  const link = card.querySelector('.card__heading a[href], a.full-unstyled-link[href]');
  if (link) {
    window.location.href = link.href;
  }
});